import {ActionConst} from '../../actions/acesso/CoAcesso'

const initialState = {
  acessos: [],
  expressao: '',
  sort: {
    property: 'id',
    asc: true //Menor para o Maior
  },
  filter_property: [
    'group', 'name', 'client_key'
  ],
  dataSource: [],
  isFetching: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case ActionConst.SET_ACESSOS:
      return {...state, acessos: action.acessos}
    case ActionConst.SET_FILTRO:
      return {...state, ...action.args}
    case ActionConst.SET_SORT:
      return {...state, sort: action.sort}
    case ActionConst.SET_DATASOURCE:
      return {...state, dataSource: action.dataSource}
    case ActionConst.IS_FETCHING:
      return {...state, isFetching: action.isFetching}
    case ActionConst.ADD:
      return {...state, acessos: [...state.acessos, action.acesso]}
    case ActionConst.EDIT:
      return {
        ...state,
        acessos: state.acessos.map((acesso) => {
          if (acesso.id === action.acesso.id) {
            return {...acesso, ...action.acesso}
          }
          return acesso
        })
      }
    case ActionConst.REMOVE:
      return {
        ...state,
        acessos: state.acessos.filter((acesso) => (acesso.id !== action.id))
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/acesso/CoAcesso.js